<script setup lang="ts">
import FileDropArea from "@/components/form/FileDropArea.vue"
import { computed } from "vue"

const props = defineProps<{
    context: any
}>()

const files = computed<File[]>({
    get: () => props.context.value ?? [],
    set: (value: File[]) => props.context.node.input(value),
})
</script>

<template>
    <FileDropArea v-model="files" :accept="context.accept" :max-files="context.maxFiles" />
</template>
